import React from 'react';
import { v4 as uuidv4 } from 'uuid';
// Generate random avatar URLs
const avatars = ['https://images.unsplash.com/photo-1494790108377-be9c29b29330', 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde', 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80', 'https://images.unsplash.com/photo-1527980965255-d3b416303d12'];
// Random usernames
const usernames = ['community_helper', 'volunteer_fan', 'earth_lover', 'do_gooder', 'helping_hand', 'change_maker', 'social_impact', 'kind_soul', 'planet_saver', 'local_activist'];
// Random post content templates
const postTemplates = ['Looking for ways to help animals in my area. Any shelters need volunteers?', 'Feeling sad about all the homeless people in our city. Want to help somehow.', 'My local beach is covered in trash. How can I help clean it up?', 'Want to volunteer with kids and help them learn to read. Any suggestions?', 'Hospitals must be overwhelmed right now. Are they taking volunteers?', 'Thinking about volunteering at an animal shelter this weekend. Anyone done this before?', 'The food bank in our area needs help. Who wants to join me this Saturday?', 'Saw a documentary about ocean pollution and feeling motivated to help clean beaches.', 'Looking for literacy programs where I can volunteer and help kids read.', 'Wish I could do something to help healthcare workers. Any volunteer opportunities?', 'The animal shelter needs blanket donations. Anyone know where I can drop them off?', 'Want to help with food insecurity in my community. Where to start?', 'Anyone know of environmental cleanup events happening this month?', 'Thinking about volunteering to help teach reading at the library. Good idea?', 'Our local hospital has a volunteer program. Has anyone participated?'];
// Generate a random timestamp within the last 24 hours
const randomTimestamp = () => {
  const now = new Date();
  const hoursAgo = Math.floor(Math.random() * 24);
  const minutesAgo = Math.floor(Math.random() * 60);
  const timestamp = new Date(now.getTime() - hoursAgo * 60 * 60 * 1000 - minutesAgo * 60 * 1000);
  if (hoursAgo === 0) {
    return `${minutesAgo}m ago`;
  } else {
    return `${hoursAgo}h ago`;
  }
};
// Generate random sentiment
const randomSentiment = () => {
  const sentiments = ['positive', 'negative', 'neutral'];
  return sentiments[Math.floor(Math.random() * sentiments.length)];
};
// Generate a random similarity score between 0.7 and 0.99
const randomSimilarity = () => {
  return 0.7 + Math.random() * 0.29;
};
// Generate mock posts
export const generateMockPosts = (count: number) => {
  const posts = [];
  for (let i = 0; i < count; i++) {
    posts.push({
      id: uuidv4(),
      username: usernames[Math.floor(Math.random() * usernames.length)],
      avatar: avatars[Math.floor(Math.random() * avatars.length)],
      timestamp: randomTimestamp(),
      content: postTemplates[Math.floor(Math.random() * postTemplates.length)],
      sentiment: randomSentiment(),
      similarity: randomSimilarity()
    });
  }
  return posts;
};